import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

export const supabase = createClient(supabaseUrl, supabaseKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
    flowType: 'pkce'
  },
  db: {
    schema: 'public'
  }
});

// Helper functions for items
export const items = {
  create: async (data: any) => {
    const { data: item, error } = await supabase
      .from('items')
      .insert(data)
      .select()
      .single();
    
    if (error) throw error;
    return item;
  },

  update: async (id: string, data: any) => {
    const { data: item, error } = await supabase
      .from('items')
      .update(data)
      .eq('id', id)
      .select()
      .single();
    
    if (error) throw error;
    return item;
  },

  delete: async (id: string) => {
    const { error } = await supabase
      .from('items')
      .delete()
      .eq('id', id);
    
    if (error) throw error;
  },

  getById: async (id: string) => {
    const { data, error } = await supabase
      .from('items')
      .select(`
        *,
        item_images (*),
        seller_profiles!inner (
          store_name,
          rating,
          location,
          whatsapp,
          telegram,
          messenger,
          phone
        )
      `)
      .eq('id', id)
      .single();
    
    if (error) throw error;
    return data;
  },

  getBySeller: async (sellerId: string) => {
    const { data, error } = await supabase
      .from('items')
      .select(`
        *,
        item_images (*)
      `)
      .eq('seller_id', sellerId)
      .order('created_at', { ascending: false });
    
    if (error) throw error;
    return data;
  }
};